import _reduce from 'lodash/reduce';

export const formatSortByToObject = (columnId, direction) => {
  if (!columnId || !direction) {
    return null;
  }
  return { [columnId]: direction === 'desc' ? -1 : 1 };
};

export const formatFilterToObject = (operands = []) => {
  // Flatten nested arrays and ensure only work with objects
  const flattenedOperands = operands.flat(Infinity).filter(item => 
    typeof item === 'object' && item !== null);

  // Process the flattened operands to ensure correct formatting
  const formattedOperands2 = _reduce(flattenedOperands, (result, group) => {
    if (Array.isArray(group.operands) && group.operands.length === 1) {
      result.push(group.operands[0]);
    } else if (typeof group === 'object') {
      result.push(group);
    }
    return result;
  }, []);

  // Remove any extra array layer from the result if necessary
  const finalOperands = formattedOperands2.flat();

  const filterFormat = {
    operator: 'AND',
    operands: finalOperands,
  };

  return filterFormat;
};